module.exports = __webpack_public_path__ + "img/ods.33630b7c.svg";